var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui segment" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", [
      _c("b", [_vm._v("Station name:")]),
      _vm._v(
        " " +
          _vm._s(_vm.getI18n(_vm.featureOfInterest.samplingFeature.name, "en"))
      )
    ]),
    _vm._v(" "),
    _vm.isPoint
      ? _c("div", [
          _c("div", [
            _vm._v(
              "Longitude : " +
                _vm._s(
                  _vm.featureOfInterest.samplingFeature.geometry.coordinates[0]
                )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "Latitude : " +
                _vm._s(
                  _vm.featureOfInterest.samplingFeature.geometry.coordinates[1]
                )
            )
          ]),
          _vm._v(" "),
          _vm.featureOfInterest.samplingFeature.geometry.coordinates[2] !=
          undefined
            ? _c("div", [
                _vm._v(
                  "Altitude : " +
                    _vm._s(
                      _vm.featureOfInterest.samplingFeature.geometry
                        .coordinates[2]
                    )
                )
              ])
            : _vm._e()
        ])
      : _c("div", [
          _c("div", [
            _c("div", [_vm._v(_vm._s(_vm.maxLong))]),
            _vm._v(" "),
            _vm._m(1)
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(_vm._s(_vm.minLat) + "  "),
            _c("i", { staticClass: "arrow left icon" }),
            _c("i", { staticClass: "arrow right icon" }, [
              _vm._v(" " + _vm._s(_vm.maxLat))
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._m(2),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.maxLong))])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui top attached label" }, [
      _c("i", { staticClass: "map icon" }, [_vm._v(" Location: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "arrow up icon" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "arrow down icon" })])
  }
]
render._withStripped = true

export { render, staticRenderFns }